import { Component, input } from '@angular/core';
import { AgentSchedulerComponent } from '../modules/agent-scheduler/agent-scheduler.component';

@Component({
  selector: 'ava-agent-scheduler-custom-element',
  template: `<ava-agent-scheduler [params]="params()" /> `,
  standalone: true,
  imports: [AgentSchedulerComponent],
})
export class AgentSchedulerCustomElementComponent {
  params = input<string>();
}
